<template>
  <form ref="formContainer"  @submit.prevent="handleSubmit">
    <div class="row">
      <div class="col-12">
        <div class="mb-3">

          <div class="">
            <label class="text-left">Mật khẩu</label>
            <span style="color: red">&nbsp;*</span>
            <input type="hidden" v-model="model.id"/>
            <div class="input-group">
              <input
                  v-model="model.password"
                  id="pwd"
                  :type="passwordFieldType"
                  name="pwd"
                  class="form-control password-current"
                  placeholder="Nhập mật khẩu"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.password.$error,
                              }"
              />
              <div class="input-group-prepend">
                <a @click="switchVisibility" class="input-group-text">
                  <i v-if="passwordFieldType == 'text'" class="mdi mdi-eye"></i>
                  <i v-else class="mdi mdi-eye-off"></i>
                </a>
              </div>
              <div
                  v-if="submitted && !$v.model.password.required"
                  class="invalid-feedback"
              >
                Mật khẩu không được để trống.
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <hr/>
      <div class="col-12">
        <div class="mb-3">
          <label class="text-left">Mật khẩu mới</label>
          <span style="color: red">&nbsp;*</span>
          <div class="input-group">
            <input
                v-model="model.newPass"
                id="pwdnew"
                :type="passwordNewTypeChange"
                class="form-control"
                placeholder="Nhập mật khẩu mới"
                :class="{
                                'is-invalid':
                                  submitted && $v.model.newPass.$error,
                              }"
            />
            <div class="input-group-prepend">
              <a @click="switchVisibilityPasswordNewTypeChange" class="input-group-text">
                <i v-if="passwordNewTypeChange == 'text'" class="mdi mdi-eye"></i>
                <i v-else class="mdi mdi-eye-off"></i>
              </a>
            </div>
            <div
                v-if="submitted && !$v.model.newPass.required"
                class="invalid-feedback"
            >
              Mật khẩu mới không được để trống.
            </div>
            <div
                v-if="submitted && !$v.model.newPass.valid"
                class="invalid-feedback"
            >
              Mật khẩu cần có ít nhất một ký tự chữ hoa, một ký tự chữ thường, một số, một ký tự đặc biệt.
            </div>
            <div
                v-if="submitted && !$v.model.newPass.minLength"
                class="invalid-feedback"
            >
              Mật khẩu cần có ít nhất 8 ký tự.
            </div>
            <div
                v-if="submitted && !$v.model.newPass.maxLength"
                class="invalid-feedback"
            >
              Mật khẩu chỉ được tối đa 20 ký tự.
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="mb-3">
          <label class="text-left">Nhập lại mật khẩu</label>
          <span style="color: red">&nbsp;*</span>
          <div class="input-group">
            <input
                v-model="model.confirmPass"
                id="confirmpwd"
                :type="passwordConfirmTypeChange"
                class="form-control"
                placeholder="Nhập lại mật khẩu"
                :class="{
                                'is-invalid':
                                  submitted && $v.model.confirmPass.$error,
                              }"
            />
            <div class="input-group-prepend">
              <a @click="switchVisibilityPasswordConfirmTypeChange" class="input-group-text">
                <i v-if="passwordConfirmTypeChange == 'text'" class="mdi mdi-eye mdi-18px"></i>
                <i v-else class="mdi mdi-eye-off mdi-18px"></i>
              </a>
            </div>
            <div
                v-if="submitted && !$v.model.confirmPass.required"
                class="invalid-feedback"
            >
              Vui lòng nhập lại mật khẩu.
            </div>
            <div
                v-if="submitted && !$v.model.confirmPass && !$v.model.confirmPass.sameAsPassword"
                class="invalid-feedback"
            >
              Nhập lại mật khẩu và mật khẩu mới không trùng khớp.
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="text-end pt-2">
      <b-button  size="md" variant="primary" type="submit" class="w-md">
        <i class="mdi mdi-key-chain text-white"></i>
        Đổi mật khẩu
      </b-button>
    </div>
    <div class="d-flex align-content-center" style="cursor: pointer">
      <i class="mdi mdi-keyboard-backspace mdi-18px" style="color: #00568C" variant="primary"></i>
      <a href="javascript:void(0)" @click="logoutUser()" class="w-md" style="vertical-align: middle;text-align: center;line-height: 26px; "> Trở về trang đăng nhập
      </a>
    </div>
  </form>
</template>

<script>
import LetterCube from "@/components/LetterCube";
import {notifyModel} from "@/models/notifyModel";
import {maxLength, minLength, required, sameAs} from "vuelidate/lib/validators";

export default {
  name: "ChangePassword",
  data() {
    return {
      showModal: false,
      submitted: false,
      model: {
        password: null,
        newPass: null,
        confirmPass: null,
        userName: null,
        id: null
      },
      passwordFieldType: "password",
      passwordNewTypeChange: "password",
      passwordConfirmTypeChange: "password",
    }
  },
  created() {

    let user = this.$store.state.authStore.authUser;
    console.log(user)
    if(user){
      if(user.isRequireChangePassword){
        this.showModal = true;
        this.model.id = user.userId;
        this.model.userName = user.user.userName
      }
    }
  },
  validations: {
    model: {
      password: {required},
      newPass: {
        required,
        valid: function (value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[#?!@$%^&*-]/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        },
        minLength: minLength(8),
        maxLength: maxLength(20),
      },
      confirmPass: {required, sameAsPassword: sameAs('newPass')}
    }
  },
  methods: {
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      var userLocalStorage = localStorage.getItem("user-token");
      if (userLocalStorage) {
        localStorage.removeItem("user-token");
        localStorage.removeItem("auth-user");
        localStorage.removeItem("TabData");
        this.$router.push("/dang-nhap");
        return;
      }
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
    },
    switchVisibilityPasswordNewTypeChange() {
      this.passwordNewTypeChange = this.passwordNewTypeChange === "password" ? "text" : "password";
    },
    switchVisibilityPasswordConfirmTypeChange() {
      this.passwordConfirmTypeChange = this.passwordConfirmTypeChange === "password" ? "text" : "password";
    },
    async handleSubmit(e) {
      e.preventDefault();
      console.log(this.$v)
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        }, {
          default: this.$createElement(LetterCube),
        });
        await this.$store.dispatch("userStore/changePassword", this.model).then(async (res) => {
          if (res.resultCode === 'SUCCESS') {
            await new Promise(resolve => setTimeout(resolve, 1000));
            localStorage.removeItem("user-token");
            localStorage.removeItem("auth-user");
            localStorage.removeItem("TabData");
            window.location.href = "/dang-nhap"
            return;
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        })
            .finally(() => {
              loader.hide();
            });
      }
      this.submitted = false;
    }
  }
}
</script>

<style scoped>
.input-group-text{
  border-radius: 0 5px 5px 0 !important;
}
</style>
